import Crud from '@/views/ManualCheck/Crud'
import Add from '@/views/ManualCheck/Add'

const routes = {
  path: '/manualChecks',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/manualChecks',
      name: 'Pontos Manuais',
      component: Crud,
    },
    {
      path: '/checks/add',
      name: 'Ponto Manual',
      component: Add,
    },
    {
      path: '/checks/edit/:id?',
      name: 'Ponto Manual',
      component: Add,
    },
  ],
}

export default routes
